// 账号信息管理
import accountInfoCenter from '@/views/accountInfoCenter/accountInfoCenter'
import userInfoCenter from '@/views/accountInfoCenter/userInfoCenter'
import loginLog from '@/views/accountInfoCenter/loginLog'
export default {
  path: '/accountInfoCenter',
  name: 'accountInfoCenter',
  component: accountInfoCenter,
  meta: {
    keepAlive: true,
    title: '账号信息管理',
    activeName: '/accountInfoCenter',
    name: 'accountInfoCenter'
  },
  children: [
    {
      path: 'userInfoCenter',
      name: 'userInfoCenter',
      component: userInfoCenter,
      sidebar: false,
      meta: {
        keepAlive: true,
        title: '我的账号',
        iconName: 'icon-client',
        subMenuShow: false
      }
    },
    {
      path: 'loginLog',
      name: 'loginLog',
      component: loginLog,
      sidebar: false,
      meta: {
        title: '登录记录',
        iconName: 'icon-menuCz',
        keepAlive: true
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/accountInfoCenter.js